/**
 * logo-slider.js — băng logo nhà cung cấp ở trang chủ.
 *
 * Markup đầu vào chỉ cần track + các ô logo:
 *   [data-logo-slider] > ul[data-logo-track] > li.logo-slider__item
 * Nút prev · pause · next do script này chèn vào [data-logo-controls] (nếu không
 * có thì chèn thẳng vào slider), nên template WordPress chỉ việc lặp qua term.
 *
 * Khác hero-slider ở chỗ mỗi lần chuyển là **một trang** chứ không phải một ô:
 * số logo trên mỗi trang do CSS quyết định (2 · 3 · 5 theo khổ màn hình), JS chỉ
 * cuộn đi đúng một chiều rộng track nên không phải đọc lại breakpoint.
 *
 * Cuộn ngang + scroll-snap của CSS lo phần vuốt trên cảm ứng; JS lỗi thì băng
 * logo vẫn vuốt xem được đủ.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var INTERVAL = 4000;

    var root = document.querySelector('[data-logo-slider]');
    if (!root) return;

    var track = root.querySelector('[data-logo-track]');
    if (!track || track.children.length < 2) return;

    var host = document.querySelector('[data-logo-controls]') || root;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var pausedByUser = false;

    root.setAttribute('role', 'group');

    // Vuốt được bằng bàn phím: vùng cuộn phải nhận được focus
    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', 'Supplier logos, scrollable');

    function maxScroll() {
        return track.scrollWidth - track.clientWidth;
    }

    function overflows() {
        return maxScroll() > 1;
    }

    // Trang cuối thường chỉ còn vài logo nên dùng ceil, và phải kẹp lại theo
    // maxScroll: nếu tính theo bội số chiều rộng track thì trang cuối cuộn hụt,
    // current() trả về số cũ và nút next đứng im ở cuối băng.
    function pages() {
        return Math.max(1, Math.ceil((track.scrollWidth - 1) / track.clientWidth));
    }

    function current() {
        if (track.scrollLeft >= maxScroll() - 1) return pages() - 1;
        return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
        var total = pages();
        var next = ((index % total) + total) % total;
        var left = Math.min(next * track.clientWidth, maxScroll());

        if (track.scrollTo) {
            track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
        } else {
            track.scrollLeft = left;
        }
    }

    // ----- Nút điều khiển -----
    function makeButton(className, label, icon) {
        var button = document.createElement('button');
        button.className = className;
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.innerHTML = '<i class="ph ' + icon + '" aria-hidden="true"></i>';
        return button;
    }

    var prev = makeButton('logo-slider__nav', 'Previous logos', 'ph-caret-left');
    var pause = makeButton('logo-slider__nav logo-slider__nav--pause', 'Pause logo rotation', 'ph-pause');
    var next = makeButton('logo-slider__nav', 'Next logos', 'ph-caret-right');

    host.appendChild(prev);
    if (!reduced) host.appendChild(pause);
    host.appendChild(next);

    prev.addEventListener('click', function () {
        goTo(current() - 1);
        stop(true);
    });

    next.addEventListener('click', function () {
        goTo(current() + 1);
        stop(true);
    });

    pause.addEventListener('click', function () {
        if (timer) {
            stop(true);
        } else {
            pausedByUser = false;
            start();
        }
    });

    function renderPause() {
        var running = !!timer;
        pause.setAttribute('aria-label', running ? 'Pause logo rotation' : 'Resume logo rotation');
        pause.innerHTML = '<i class="ph ' + (running ? 'ph-pause' : 'ph-play') + '" aria-hidden="true"></i>';
    }

    // Đủ chỗ xếp hết logo thì giấu nút đi cho gọn
    function syncControls() {
        var show = overflows();
        host.hidden = !show;
        if (!show) stop(false);
        else if (!pausedByUser) start();
    }

    // ----- Tự chạy -----
    function start() {
        if (reduced || pausedByUser || timer || !overflows()) return;
        timer = window.setInterval(function () {
            goTo(current() + 1);
        }, INTERVAL);
        renderPause();
    }

    function stop(byUser) {
        if (byUser) pausedByUser = true;
        window.clearInterval(timer);
        timer = null;
        renderPause();
    }

    root.addEventListener('mouseenter', function () {
        if (timer) stop(false);
    });
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', function () {
        if (timer) stop(false);
    });
    root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            stop(false);
        } else {
            start();
        }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(syncControls, 200);
    });

    syncControls();
})();
